export default "/images/vendor/@coreui/icons/svg/flag/cif-ag.svg?77b189f1bf0dc7b6909ac2f9beb6e83f";